import GoogleAnalytics from './GoogleAnalytics.container';
export default GoogleAnalytics;